(function () {
  function qs(sel, root) {
    return (root || document).querySelector(sel);
  }
  function qsa(sel, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  }

  /* Mobile nav — prevent page sideways shift when drawer opens */
  var menuToggle = qs('[data-menu-toggle]');
  var menuPanel = qs('[data-menu-panel]');
  var menuClose = qs('[data-menu-close]');
  var menuOverlay = qs('[data-menu-overlay]');
  var drawerLockCount = 0;

  function lockBodyScroll(lock) {
    if (lock) {
      if (drawerLockCount === 0) {
        var y = window.scrollY || window.pageYOffset || 0;
        document.body.dataset.scrollLockY = String(y);
        document.body.classList.add('is-drawer-open');
        document.body.style.top = '-' + y + 'px';
      }
      drawerLockCount += 1;
    } else {
      drawerLockCount = Math.max(0, drawerLockCount - 1);
      if (drawerLockCount === 0) {
        var y2 = parseInt(document.body.dataset.scrollLockY || '0', 10) || 0;
        document.body.classList.remove('is-drawer-open');
        document.body.style.top = '';
        delete document.body.dataset.scrollLockY;
        window.scrollTo(0, y2);
      }
    }
  }
  window.oniviasLockBodyScroll = lockBodyScroll;

  function setMenu(open) {
    if (!menuPanel) return;
    var wasOpen = !menuPanel.hidden;
    menuPanel.hidden = !open;
    if (menuOverlay) menuOverlay.hidden = !open;
    if (open && !wasOpen) lockBodyScroll(true);
    if (!open && wasOpen) lockBodyScroll(false);
    if (menuToggle) menuToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (open && menuClose) menuClose.focus();
    else if (!open && menuToggle) menuToggle.focus();
  }

  if (menuToggle) menuToggle.addEventListener('click', function () { setMenu(true); });
  if (menuClose) menuClose.addEventListener('click', function () { setMenu(false); });
  if (menuOverlay) menuOverlay.addEventListener('click', function () { setMenu(false); });

  /* Desktop navigation menu (hover + click, subcategory panels) */
  (function initNavMenu() {
    var root = qs('[data-nav-menu]');
    if (!root) return;
    var items = qsa('[data-nav-item].has-children', root);
    var closeTimer = null;

    function closeAll(except) {
      items.forEach(function (item) {
        if (except && item === except) return;
        item.classList.remove('is-open');
        var trigger = qs('[data-nav-trigger]', item);
        var content = qs('[data-nav-content]', item);
        if (trigger) trigger.setAttribute('aria-expanded', 'false');
        if (content) content.hidden = true;
      });
    }

    function openItem(item) {
      closeAll(item);
      item.classList.add('is-open');
      var trigger = qs('[data-nav-trigger]', item);
      var content = qs('[data-nav-content]', item);
      if (trigger) trigger.setAttribute('aria-expanded', 'true');
      if (content) content.hidden = false;
    }

    items.forEach(function (item) {
      var trigger = qs('[data-nav-trigger]', item);
      if (!trigger) return;

      item.addEventListener('mouseenter', function () {
        if (window.matchMedia('(min-width: 990px)').matches) {
          clearTimeout(closeTimer);
          openItem(item);
        }
      });
      item.addEventListener('mouseleave', function () {
        if (window.matchMedia('(min-width: 990px)').matches) {
          closeTimer = setTimeout(function () { closeAll(); }, 120);
        }
      });
      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        var isOpen = item.classList.contains('is-open');
        if (isOpen) closeAll();
        else openItem(item);
      });
    });

    document.addEventListener('click', function (e) {
      if (!root.contains(e.target)) closeAll();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeAll();
    });
  })();

  /* Mobile accordion for subcategories */
  qsa('[data-mobile-accordion]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var id = btn.getAttribute('aria-controls');
      var panel = id ? document.getElementById(id) : null;
      if (!panel) return;
      var open = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', open ? 'false' : 'true');
      panel.hidden = open;
    });
  });

  /* Account menu */
  qsa('[data-account-menu]').forEach(function (root) {
    var toggle = qs('[data-account-toggle]', root);
    var panel = qs('[data-account-panel]', root);
    if (!toggle || !panel) return;

    function setOpen(open) {
      panel.hidden = !open;
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    }

    toggle.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      setOpen(panel.hidden);
    });

    document.addEventListener('click', function (e) {
      if (!root.contains(e.target)) setOpen(false);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') setOpen(false);
    });
  });

  /* Cart drawer */
  var drawer = qs('[data-cart-drawer]');
  var drawerOverlay = qs('[data-cart-drawer-overlay]');

  function setDrawer(open) {
    if (!drawer) return;
    var wasOpen = !drawer.hidden;
    if (open) {
      var wish = qs('[data-wishlist-drawer]');
      var wishOverlay = qs('[data-wishlist-drawer-overlay]');
      if (wish && !wish.hidden) {
        wish.hidden = true;
        if (wishOverlay) wishOverlay.hidden = true;
        lockBodyScroll(false);
      }
    }
    drawer.hidden = !open;
    if (drawerOverlay) drawerOverlay.hidden = !open;
    if (open && !wasOpen) lockBodyScroll(true);
    if (!open && wasOpen) lockBodyScroll(false);
  }

  qsa('[data-cart-open]').forEach(function (el) {
    el.addEventListener('click', function (e) {
      if (drawer && drawer.dataset.enabled === 'true') {
        e.preventDefault();
        setDrawer(true);
      }
    });
  });
  qsa('[data-cart-close]').forEach(function (el) {
    el.addEventListener('click', function () { setDrawer(false); });
  });
  if (drawerOverlay) drawerOverlay.addEventListener('click', function () { setDrawer(false); });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      setMenu(false);
      setDrawer(false);
      var wish = qs('[data-wishlist-drawer]');
      var wishOverlay = qs('[data-wishlist-drawer-overlay]');
      if (wish && !wish.hidden) {
        wish.hidden = true;
        if (wishOverlay) wishOverlay.hidden = true;
        lockBodyScroll(false);
      }
    }
  });

  /* Hero slider */
  qsa('[data-hero-slider]').forEach(function (slider) {
    var track = qs('[data-hero-track]', slider);
    var slides = qsa('[data-hero-slide]', slider);
    if (!track || slides.length < 2) return;
    var index = 0;
    var timer;

    function go(i) {
      index = (i + slides.length) % slides.length;
      track.style.transform = 'translateX(-' + index * 100 + '%)';
      slides.forEach(function (s, n) {
        s.setAttribute('aria-hidden', n === index ? 'false' : 'true');
      });
      qsa('[data-hero-dot]', slider).forEach(function (dot, n) {
        var on = n === index;
        dot.classList.toggle('is-active', on);
        if (on) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
    }

    function play() {
      stop();
      timer = setInterval(function () { go(index + 1); }, 5500);
    }
    function stop() {
      if (timer) clearInterval(timer);
    }

    var prev = qs('[data-hero-prev]', slider);
    var next = qs('[data-hero-next]', slider);
    if (prev) prev.addEventListener('click', function () { go(index - 1); play(); });
    if (next) next.addEventListener('click', function () { go(index + 1); play(); });
    qsa('[data-hero-dot]', slider).forEach(function (dot) {
      dot.addEventListener('click', function () {
        go(Number(dot.getAttribute('data-index')) || 0);
        play();
      });
    });

    // swipe
    var startX = 0;
    track.addEventListener('touchstart', function (e) {
      startX = e.changedTouches[0].screenX;
      stop();
    }, { passive: true });
    track.addEventListener('touchend', function (e) {
      var dx = e.changedTouches[0].screenX - startX;
      if (Math.abs(dx) > 40) go(index + (dx < 0 ? 1 : -1));
      play();
    }, { passive: true });

    slider.addEventListener('mouseenter', stop);
    slider.addEventListener('mouseleave', play);
    go(0);
    play();
  });

  /* Announcement dismiss */
  qsa('[data-announcement-dismiss]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var bar = btn.closest('[data-announcement]');
      if (bar) bar.hidden = true;
      try { sessionStorage.setItem('gz-announcement-dismissed', '1'); } catch (err) {}
    });
  });
  if (sessionStorage.getItem('gz-announcement-dismissed') === '1') {
    qsa('[data-announcement]').forEach(function (el) { el.hidden = true; });
  }

  /* Reveal on scroll */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });
    qsa('[data-reveal]').forEach(function (el) { io.observe(el); });
  } else {
    qsa('[data-reveal]').forEach(function (el) { el.classList.add('is-visible'); });
  }

  /* Product carousels — arrows + finger/mouse drag scroll */
  qsa('[data-product-carousel]').forEach(function (carousel) {
    var track = qs('[data-carousel-track]', carousel);
    var prev = qs('[data-carousel-prev]', carousel);
    var next = qs('[data-carousel-next]', carousel);
    if (!track) return;

    var scroller = track.closest('.featured-rail__carousel') || track;

    function scrollByCard(dir) {
      var amount = Math.max(scroller.clientWidth * 0.75, 240);
      scroller.scrollBy({ left: dir * amount, behavior: 'smooth' });
    }
    if (prev) prev.addEventListener('click', function () { scrollByCard(-1); });
    if (next) next.addEventListener('click', function () { scrollByCard(1); });

    if (scroller.dataset.dragBound === '1') return;
    scroller.dataset.dragBound = '1';

    var dragging = false;
    var startX = 0;
    var startScroll = 0;
    var moved = false;

    function onDown(e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      /* Başlık / sepete ekle / wishlist tıklaması sürüklemeyi başlatmasın */
      if (e.target.closest('button, input, select, textarea, label, [data-wishlist-toggle]')) return;
      if (e.target.closest('a') && !e.target.closest('a.product-card__media-link')) return;
      dragging = true;
      moved = false;
      scroller.dataset.carouselDragged = '0';
      startX = e.clientX;
      startScroll = scroller.scrollLeft;
      scroller.classList.add('is-dragging');
      try { scroller.setPointerCapture(e.pointerId); } catch (err) {}
    }

    function onMove(e) {
      if (!dragging) return;
      var dx = e.clientX - startX;
      if (Math.abs(dx) > 10) moved = true;
      if (moved) {
        scroller.dataset.carouselDragged = '1';
        scroller.scrollLeft = startScroll - dx;
        e.preventDefault();
      }
    }

    function onUp() {
      if (!dragging) return;
      dragging = false;
      scroller.classList.remove('is-dragging');
      if (moved) {
        scroller.dataset.carouselDragged = '1';
        setTimeout(function () { scroller.dataset.carouselDragged = '0'; }, 120);
      }
    }

    scroller.addEventListener('pointerdown', onDown);
    scroller.addEventListener('pointermove', onMove, { passive: false });
    scroller.addEventListener('pointerup', onUp);
    scroller.addEventListener('pointercancel', onUp);

    scroller.addEventListener('click', function (e) {
      if (scroller.dataset.carouselDragged !== '1') return;
      /* Sürükleme sonrası yalnızca medya linkini iptal et; başlık her zaman açılsın */
      if (e.target.closest('a.product-card__media-link')) {
        e.preventDefault();
        e.stopPropagation();
      }
    }, true);
  });

  /* Product card hover image peeks — stacked slides, instant switch */
  function initCardMedia(scope) {
    qsa('[data-card-media]', scope || document).forEach(function (media) {
      if (media.getAttribute('data-card-ready') === '1') return;
      var slides = qsa('[data-card-slide]', media);
      var peeks = qsa('[data-card-peek]', media);
      var dots = qsa('[data-card-dot]', media);
      if (slides.length < 2 || peeks.length < 2) return;

      media.setAttribute('data-card-ready', '1');
      var active = 0;

      function showAt(index) {
        if (index === active || !slides[index]) return;
        slides[active].classList.remove('is-active');
        slides[index].classList.add('is-active');
        if (dots[active]) dots[active].classList.remove('is-active');
        if (dots[index]) dots[index].classList.add('is-active');
        active = index;
      }

      peeks.forEach(function (peek, index) {
        peek.addEventListener('mouseenter', function () {
          showAt(index);
        });
        peek.addEventListener('mousemove', function () {
          showAt(index);
        });
      });
      media.addEventListener('mouseleave', function () {
        showAt(0);
      });
    });
  }
  initCardMedia();

  /* Collection infinite scroll */
  qsa('[data-infinite-scroll]').forEach(function (root) {
    var grid = qs('[data-collection-grid]');
    var status = qs('[data-infinite-status]', root);
    var sentinel = qs('[data-infinite-sentinel]', root);
    if (!grid || !sentinel) return;

    var nextUrl = root.getAttribute('data-next-url') || '';
    var loading = false;

    function setLoading(on) {
      loading = on;
      if (status) status.hidden = !on;
    }

    function loadNext() {
      if (loading || !nextUrl) return;
      setLoading(true);
      fetch(nextUrl, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (res) { return res.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var nextGrid = doc.querySelector('[data-collection-grid]');
          var nextRoot = doc.querySelector('[data-infinite-scroll]');
          if (nextGrid) {
            Array.prototype.slice.call(nextGrid.children).forEach(function (card) {
              grid.appendChild(document.importNode(card, true));
            });
            initCardMedia(grid);
          }
          nextUrl = nextRoot ? (nextRoot.getAttribute('data-next-url') || '') : '';
          root.setAttribute('data-next-url', nextUrl);
          if (!nextUrl) {
            if (observer) observer.disconnect();
            root.hidden = true;
          }
        })
        .catch(function () {
          /* keep sentinel for retry on next intersect */
        })
        .finally(function () {
          setLoading(false);
        });
    }

    var observer = null;
    if ('IntersectionObserver' in window) {
      observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) loadNext();
        });
      }, { rootMargin: '600px 0px' });
      observer.observe(sentinel);
    } else {
      window.addEventListener('scroll', function () {
        var rect = sentinel.getBoundingClientRect();
        if (rect.top < window.innerHeight + 600) loadNext();
      }, { passive: true });
    }
  });

  /* Announcement slider (Evidea-style top bar) */
  qsa('[data-announcement-slider]').forEach(function (root) {
    var slides = qsa('[data-announcement-slide]', root);
    if (slides.length < 2) return;
    var i = 0;
    setInterval(function () {
      slides[i].hidden = true;
      slides[i].classList.remove('is-active');
      i = (i + 1) % slides.length;
      slides[i].hidden = false;
      slides[i].classList.add('is-active');
    }, 4000);
  });

  /* Instagram-style Story Viewer (21st.dev adapted) — event delegation survives section reloads */
  (function initStoryViewer() {
    var STORAGE_KEY = 'onivias-story-viewed';
    var active = null;

    function loadViewed() {
      try { return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]'); }
      catch (e) { return []; }
    }
    function saveViewed(ids) {
      try { localStorage.setItem(STORAGE_KEY, JSON.stringify(ids)); }
      catch (e) {}
    }

    function getRoot(fromEl) {
      return fromEl ? fromEl.closest('[data-story-viewer]') : qs('[data-story-viewer]');
    }

    function collectStories(root) {
      return qsa('[data-story-open]', root).map(function (btn) {
        return {
          id: btn.getAttribute('data-story-id') || '',
          label: btn.getAttribute('data-story-label') || '',
          src: btn.getAttribute('data-story-src') || '',
          avatar: btn.getAttribute('data-story-avatar') || btn.getAttribute('data-story-src') || '',
          href: btn.getAttribute('data-story-href') || '/',
          el: btn
        };
      });
    }

    function applyViewedState(root) {
      var ids = loadViewed();
      qsa('[data-story-open]', root).forEach(function (btn) {
        var id = btn.getAttribute('data-story-id') || '';
        btn.classList.toggle('is-viewed', ids.indexOf(id) !== -1);
      });
    }

    function markViewed(id, root) {
      var ids = loadViewed();
      if (ids.indexOf(id) === -1) {
        ids.push(id);
        saveViewed(ids);
      }
      applyViewedState(root);
    }

    function stopLoop(state) {
      if (state && state.raf) cancelAnimationFrame(state.raf);
      if (state) {
        state.raf = null;
        state.lastTs = 0;
      }
    }

    function paintProgress(state) {
      qsa('[data-fill]', state.progressEl).forEach(function (fill, i) {
        if (i < state.index) fill.style.width = '100%';
        else if (i === state.index) fill.style.width = state.progress + '%';
        else fill.style.width = '0%';
      });
    }

    function buildProgress(state) {
      state.progressEl.innerHTML = '';
      state.stories.forEach(function (_, i) {
        var seg = document.createElement('div');
        seg.className = 'story-viewer__progress-seg';
        var fill = document.createElement('span');
        fill.className = 'story-viewer__progress-fill';
        fill.setAttribute('data-fill', String(i));
        seg.appendChild(fill);
        state.progressEl.appendChild(seg);
      });
    }

    function showStory(state, i) {
      state.index = Math.max(0, Math.min(i, state.stories.length - 1));
      var s = state.stories[state.index];
      state.mediaEl.src = s.src;
      state.mediaEl.alt = s.label;
      state.avatarEl.src = s.avatar || s.src;
      state.nameEl.textContent = s.label;
      state.ctaEl.href = s.href;
      state.ctaEl.textContent = 'İncele';
      state.progress = 0;
      state.lastTs = 0;
      paintProgress(state);
      markViewed(s.id, state.root);
    }

    function closeModal(state) {
      if (!state) state = active;
      if (!state) return;
      stopLoop(state);
      state.modal.hidden = true;
      document.documentElement.style.overflow = '';
      document.body.style.overflow = '';
      state.mediaEl.removeAttribute('src');
      if (active === state) active = null;
    }

    function setPaused(state, paused) {
      state.paused = paused;
      if (state.pausedBadge) state.pausedBadge.hidden = !paused;
      if (!paused) state.lastTs = 0;
    }

    function tick(state, ts) {
      if (!active || active !== state) return;
      if (!state.paused) {
        if (!state.lastTs) state.lastTs = ts;
        var delta = ts - state.lastTs;
        state.lastTs = ts;
        state.progress = Math.min(100, state.progress + (delta / state.duration) * 100);
        paintProgress(state);
        if (state.progress >= 100) {
          if (state.index < state.stories.length - 1) {
            showStory(state, state.index + 1);
          } else {
            closeModal(state);
            return;
          }
        }
      } else {
        state.lastTs = 0;
      }
      state.raf = requestAnimationFrame(function (t) { tick(state, t); });
    }

    function openModal(root, startIndex) {
      var modal = qs('[data-story-modal]', root);
      var mediaEl = qs('[data-story-media]', root);
      var progressEl = qs('[data-story-progress]', root);
      var avatarEl = qs('[data-story-modal-avatar]', root);
      var nameEl = qs('[data-story-modal-name]', root);
      var ctaEl = qs('[data-story-cta]', root);
      var pausedBadge = qs('[data-story-paused-badge]', root);
      var stories = collectStories(root);
      if (!modal || !mediaEl || !stories.length) return;

      if (active) closeModal(active);

      var state = {
        root: root,
        modal: modal,
        mediaEl: mediaEl,
        progressEl: progressEl,
        avatarEl: avatarEl,
        nameEl: nameEl,
        ctaEl: ctaEl,
        pausedBadge: pausedBadge,
        stories: stories,
        index: 0,
        progress: 0,
        paused: false,
        raf: null,
        lastTs: 0,
        duration: parseInt(getComputedStyle(root).getPropertyValue('--story-duration'), 10) || 5000
      };

      active = state;
      buildProgress(state);
      showStory(state, startIndex);
      modal.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      document.body.style.overflow = 'hidden';
      setPaused(state, false);
      stopLoop(state);
      state.raf = requestAnimationFrame(function (t) { tick(state, t); });
    }

    document.addEventListener('click', function (e) {
      var openBtn = e.target.closest('[data-story-open]');
      if (openBtn) {
        var viewport = openBtn.closest('.story-viewer__viewport');
        if (viewport && viewport.dataset.storyDragged === '1') {
          e.preventDefault();
          e.stopPropagation();
          return;
        }
        e.preventDefault();
        var root = getRoot(openBtn);
        if (!root) return;
        openModal(root, Number(openBtn.getAttribute('data-story-index')) || 0);
        return;
      }

      if (!active) return;

      if (e.target.closest('[data-story-close]')) {
        e.preventDefault();
        closeModal(active);
        return;
      }
      if (e.target.closest('[data-story-tap-prev]')) {
        e.preventDefault();
        if (active.index > 0) showStory(active, active.index - 1);
        else { active.progress = 0; paintProgress(active); }
        return;
      }
      if (e.target.closest('[data-story-tap-next]')) {
        e.preventDefault();
        if (active.index < active.stories.length - 1) showStory(active, active.index + 1);
        else closeModal(active);
        return;
      }
      if (e.target === active.modal) closeModal(active);
    });

    document.addEventListener('pointerdown', function (e) {
      if (!active) return;
      if (!e.target.closest('[data-story-frame]')) return;
      if (e.target.closest('.story-viewer__icon-btn, .story-viewer__cta, .story-viewer__tap')) return;
      setPaused(active, true);
    });
    document.addEventListener('pointerup', function () {
      if (active) setPaused(active, false);
    });
    document.addEventListener('pointercancel', function () {
      if (active) setPaused(active, false);
    });

    document.addEventListener('keydown', function (e) {
      if (!active) return;
      if (e.key === 'Escape') closeModal(active);
      else if (e.key === 'ArrowLeft') {
        if (active.index > 0) showStory(active, active.index - 1);
      } else if (e.key === 'ArrowRight') {
        if (active.index < active.stories.length - 1) showStory(active, active.index + 1);
        else closeModal(active);
      } else if (e.key === ' ') {
        e.preventDefault();
        setPaused(active, !active.paused);
      }
    });

    /* Finger / mouse drag scroll on story strip */
    function bindStoryScroll(root) {
      var viewport = qs('.story-viewer__viewport', root);
      if (!viewport || viewport.dataset.scrollBound === '1') return;
      viewport.dataset.scrollBound = '1';

      var dragging = false;
      var startX = 0;
      var startScroll = 0;
      var moved = false;

      function onDown(e) {
        if (e.pointerType === 'mouse' && e.button !== 0) return;
        dragging = true;
        moved = false;
        viewport.dataset.storyDragged = '0';
        startX = e.clientX;
        startScroll = viewport.scrollLeft;
        viewport.classList.add('is-dragging');
        try { viewport.setPointerCapture(e.pointerId); } catch (err) {}
      }

      function onMove(e) {
        if (!dragging) return;
        var dx = e.clientX - startX;
        if (Math.abs(dx) > 6) moved = true;
        if (moved) {
          viewport.dataset.storyDragged = '1';
          viewport.scrollLeft = startScroll - dx;
        }
      }

      function onUp() {
        if (!dragging) return;
        dragging = false;
        viewport.classList.remove('is-dragging');
        if (moved) {
          viewport.dataset.storyDragged = '1';
          setTimeout(function () { viewport.dataset.storyDragged = '0'; }, 80);
        }
      }

      viewport.addEventListener('pointerdown', onDown);
      viewport.addEventListener('pointermove', onMove);
      viewport.addEventListener('pointerup', onUp);
      viewport.addEventListener('pointercancel', onUp);
    }

    function boot() {
      qsa('[data-story-viewer]').forEach(function (root) {
        applyViewedState(root);
        bindStoryScroll(root);
      });
    }
    boot();
    document.addEventListener('shopify:section:load', boot);
  })();

  /* Footer trust promo — mobile carousel, desktop wrap grid */
  qsa('[data-footer-trust]').forEach(function (root) {
    var track = qs('[data-footer-trust-track]', root);
    var slides = qsa('[data-footer-trust-slide]', root);
    var dots = qsa('[data-footer-trust-dot]', root);
    if (!track || slides.length < 2) return;

    var index = 0;
    var mq = window.matchMedia('(min-width: 990px)');

    function isDesktop() {
      return mq.matches;
    }

    function go(i) {
      if (isDesktop()) {
        track.style.transform = '';
        return;
      }
      index = (i + slides.length) % slides.length;
      track.style.transform = 'translateX(-' + index * 100 + '%)';
      dots.forEach(function (dot, n) {
        dot.classList.toggle('is-active', n === index);
      });
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        go(Number(dot.getAttribute('data-index')) || 0);
      });
    });

    var startX = 0;
    track.addEventListener('touchstart', function (e) {
      if (isDesktop()) return;
      startX = e.changedTouches[0].screenX;
    }, { passive: true });
    track.addEventListener('touchend', function (e) {
      if (isDesktop()) return;
      var dx = e.changedTouches[0].screenX - startX;
      if (Math.abs(dx) > 40) go(index + (dx < 0 ? 1 : -1));
    }, { passive: true });

    function onChange() {
      go(isDesktop() ? 0 : index);
    }
    if (mq.addEventListener) mq.addEventListener('change', onChange);
    else if (mq.addListener) mq.addListener(onChange);
    go(0);
  });

  /* Evidea-style typewriter search placeholder */
  qsa('[data-typewriter]').forEach(function (input) {
    var full = input.getAttribute('data-typewriter-text') || '';
    if (!full) return;
    var i = 0;
    var deleting = false;
    var hold = 0;

    function tick() {
      if (document.activeElement === input || input.value) {
        input.placeholder = full;
        setTimeout(tick, 400);
        return;
      }

      if (!deleting && i < full.length) {
        i += 1;
        input.placeholder = full.slice(0, i);
        setTimeout(tick, 55 + Math.random() * 35);
        return;
      }

      if (!deleting && i >= full.length) {
        hold += 1;
        if (hold < 18) {
          setTimeout(tick, 80);
          return;
        }
        deleting = true;
        hold = 0;
      }

      if (deleting && i > 0) {
        i -= 1;
        input.placeholder = full.slice(0, i);
        setTimeout(tick, 28 + Math.random() * 20);
        return;
      }

      deleting = false;
      hold = 0;
      setTimeout(tick, 350);
    }

    input.placeholder = '';
    setTimeout(tick, 400);
  });

  /* Collection facets — mobile drawer + auto-submit */
  qsa('[data-facets]').forEach(function (root) {
    var drawer = qs('[data-facets-drawer]', root);
    var overlay = qs('[data-facets-overlay]', root);
    var openBtn = qs('[data-facets-open]', root);
    var closeBtn = qs('[data-facets-close]', root);

    function setOpen(open) {
      if (!drawer) return;
      var wasOpen = !drawer.hidden;
      drawer.hidden = !open;
      if (overlay) overlay.hidden = !open;
      if (open && !wasOpen) lockBodyScroll(true);
      if (!open && wasOpen) lockBodyScroll(false);
    }

    if (openBtn) openBtn.addEventListener('click', function () { setOpen(true); });
    if (closeBtn) closeBtn.addEventListener('click', function () { setOpen(false); });
    if (overlay) overlay.addEventListener('click', function () { setOpen(false); });
  });

  qsa('[data-facets-form]').forEach(function (form) {
    qsa('[data-facets-input]', form).forEach(function (input) {
      input.addEventListener('change', function () {
        form.submit();
      });
    });
  });

  qsa('[data-facets-sort]').forEach(function (select) {
    select.addEventListener('change', function () {
      if (select.form) select.form.submit();
    });
  });

  /* Bilgi Merkezi — client-side knowledge search */
  (function () {
    function normalize(s) {
      return String(s || '')
        .toLocaleLowerCase('tr-TR')
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .trim();
    }

    function boot(root) {
      var input = qs('[data-kb-search]', root);
      var clearBtn = qs('[data-kb-clear]', root);
      var countEl = qs('[data-kb-count]', root);
      var emptyEl = qs('[data-kb-empty]', root);
      var items = qsa('[data-kb-item]', root);
      if (!input || !items.length) return;

      function run() {
        var q = normalize(input.value);
        if (clearBtn) clearBtn.hidden = !q;
        var visible = 0;
        items.forEach(function (el) {
          var hay = normalize(el.getAttribute('data-kb-text') || el.textContent);
          var show = !q || hay.indexOf(q) !== -1;
          el.hidden = !show;
          if (show) visible += 1;
        });
        if (countEl) {
          if (q) {
            countEl.hidden = false;
            countEl.textContent = visible + ' sonuç bulundu';
          } else {
            countEl.hidden = true;
          }
        }
        if (emptyEl) emptyEl.hidden = !(q && visible === 0);
      }

      input.addEventListener('input', run);
      input.addEventListener('search', run);
      if (clearBtn) {
        clearBtn.addEventListener('click', function () {
          input.value = '';
          input.focus();
          run();
        });
      }
    }

    function init() {
      qsa('[data-kb]').forEach(boot);
    }
    init();
    document.addEventListener('shopify:section:load', init);
  })();
})();
